webpackJsonp(["help"],{

/***/ "./help/help.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// We will render the icons list here
if ($('#user-content-gitlab-icons').length > 0) {
  var $iconsHeader = $('#user-content-gitlab-icons');
  var $iconsList = $('<div id="iconsList">ICONS</div>');
  $($iconsList).insertAfter($iconsHeader.parent());
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./help/help.js"]);


// WEBPACK FOOTER //
// help.beeadb0a8273139fc2ff.bundle.js